import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from './EventsLog'

/**
 * Send OTP to user's email or phone
 * @param {Object} payload - { identifier, type, process }
 */
export const sendOtp = (payload) => (dispatch) => {
    dispatch(addEventLog(payload, CONSTANTS.SEND_OTP_REQUEST))
    dispatch({ type: CONSTANTS.SEND_OTP_REQUEST })
    return postRequest(APICONFIG.sendOtpUrl, payload).then((res) => {
        dispatch(addEventLog(res, CONSTANTS.SEND_OTP_SUCCESS))
        dispatch({ type: CONSTANTS.SEND_OTP_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch(addEventLog(err, CONSTANTS.SEND_OTP_FAILURE))
        dispatch({ type: CONSTANTS.SEND_OTP_FAILURE })
        return err
    })
}

/**
 * Verify OTP entered by user
 * @param {Object} payload - { identifier, type, otp, process }
 */
export const verifyOtp = (payload) => (dispatch) => {
    dispatch(addEventLog(payload, CONSTANTS.VERIFY_OTP_REQUEST))
    dispatch({ type: CONSTANTS.VERIFY_OTP_REQUEST })
    return postRequest(APICONFIG.verifyOtpUrl, payload).then((res) => {
        dispatch(addEventLog(res, CONSTANTS.VERIFY_OTP_SUCCESS))
        dispatch({ type: CONSTANTS.VERIFY_OTP_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch(addEventLog(err, CONSTANTS.VERIFY_OTP_FAILURE))
        dispatch({ type: CONSTANTS.VERIFY_OTP_FAILURE })
        return err
    })
}
